import { render, staticRenderFns } from "./MInstruksiKP.vue?vue&type=template&id=8e8c9df0&scoped=true&lang=html&"
import script from "./MInstruksiKP.vue?vue&type=script&lang=js&"
export * from "./MInstruksiKP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e8c9df0",
  null
  
)

export default component.exports